import Button from '@rio-cloud/rio-uikit/Button';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { mapStateToFindDiscountProps } from '../../../common/discount/DiscountService';
import { OverlayTrigger, Tooltip } from '../../../common/utils/tooltipReExports';
import { DEFAULT_TOOLTIP_DELAY } from '../../../config/config';
import type { ProductInfo } from '../redux/types';
import {
    getProductCellAutoTrackingKey,
    IconButtonPrimary,
    IconButtonSecondary,
    ProductCellTrackingAction,
} from './productCellConfig';

interface Props {
    product: ProductInfo;
    productLabel: string;
}

export const ProductCellPending = ({ product, productLabel }: Props) => {
    const intl = useIntl();

    const isFreeTrial = product.level?.endsWith('-ft');
    const buttonClasses = isFreeTrial ? IconButtonSecondary : IconButtonPrimary;

    const overlay = (
        <Tooltip id='tooltip' className={'width-auto max-width-300'}>
            {intl.formatMessage({ id: 'intl-msg:marketplace.asset.pending.activation.info' })}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            trigger={OverlayTrigger.TRIGGER_HOVER}
            placement='top'
            overlay={overlay}
            delay={DEFAULT_TOOLTIP_DELAY}
        >
            <span>
                <Button
                    className={`${buttonClasses} disabled`}
                    autoTrackingKey={getProductCellAutoTrackingKey(
                        ProductCellTrackingAction.pendingActivationInfo,
                        productLabel
                    )}
                >
                    <span className='uikit-icon icon-hour-glass' />
                </Button>
            </span>
        </OverlayTrigger>
    );
};

export const ProductCellPendingContainer = connect(mapStateToFindDiscountProps)(ProductCellPending);
